function Stock() {
  return null;
}

export default Stock;
